import PropTypes from 'prop-types';

/* 
Modal types
- iframe: Display of an external site/page
- gallery: Image gallery with automatic or manual scrolling. Configurable images, transition times and appearance times.
- zoom: One or more zoomable images. Configurable images and zoom level per image
- video: Animation in .gif, .webp or mp4 format. Configurable file 
- image : Single image. Configurable image
--- Option to play a soundtrack when a modal is opened. Configurable sound file.
*/
export const imageTypes = PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    zoomScale: PropTypes.number,
    template: PropTypes.string,
});

export const ctaTypes = PropTypes.shape({
    href: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    target: PropTypes.string,
});

export const richTextTypes = PropTypes.shape({
    title: PropTypes.string,
    subtitle:PropTypes.string,
    contentTitle:PropTypes.string,
    contentSubtitle:PropTypes.string,
    contentAuthor:PropTypes.string,
    contentIntro:PropTypes.string,
    content:PropTypes.string,
    ctas:PropTypes.arrayOf(
        ctaTypes,
    ),
})

export const contentTypes = PropTypes.shape({
    backgrounds:PropTypes.arrayOf(
        imageTypes,
    ),
    scrollables: PropTypes.arrayOf(
        PropTypes.shape({
            id:PropTypes.string,
            width: PropTypes.number,
            height: PropTypes.number,
        })
    ),
    intro:richTextTypes,
    outro:richTextTypes,
    modals:PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            type: PropTypes.string.isRequired,
            scrollableId: PropTypes.string,
            width: PropTypes.string,
            frameStyle: PropTypes.string,
            animatedButton:PropTypes.shape({
                image:PropTypes.shape({
                    src: PropTypes.string,
                    alt: PropTypes.string,
                }),
                animation: PropTypes.string,
                speed: PropTypes.number
            }),
            content: PropTypes.shape({
                link: PropTypes.string,
                title: PropTypes.string,
                popOver: PropTypes.shape({
                    title:PropTypes.string,
                    content:PropTypes.string,
                }),
                subtitle: PropTypes.string,
                autoPlay: PropTypes.bool,
                play: PropTypes.bool,
                loop: PropTypes.bool,
                speed: PropTypes.number,
                effect: PropTypes.string,
                delay: PropTypes.number,
                video: PropTypes.string,
                image:imageTypes,
                medias: PropTypes.arrayOf(
                    imageTypes,
                ),
                modalFigcaption: PropTypes.string,
                audio:{
                    src: PropTypes.string,
                    autoPlay: PropTypes.bool,
                    loop: PropTypes.bool,
                }
            }).isRequired,
            button: PropTypes.shape({
                left: PropTypes.number.isRequired,
                top: PropTypes.number.isRequired,
                width: PropTypes.number.isRequired,
                height: PropTypes.number.isRequired,
                event: PropTypes.string,
                zIndex: PropTypes.number,
            }).isRequired,
        })
    )
});

export const identityTypes = PropTypes.shape({
  site: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    fullTitle: PropTypes.string,
  }),
  menus: PropTypes.shape({
    mainMenu: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        link: PropTypes.string,
        popOver: PropTypes.shape({
            title:PropTypes.string,
            content:PropTypes.string,
        }),
        target: PropTypes.string,
      })
    ),
  })
});